<section class="custom-modal" role="dialog" aria-modal="true" aria-labelledby="supplier-code-auto-fill-title">
  <header class="modal-header">
    <h2 id="supplier-code-auto-fill-title" class="modal-title">
      @if (mode === 'confirm') {
        Update Supplier Stock Code?
      } @else {
        Supplier Stock Code Not Found
      }
    </h2>
    <button type="button" class="icon-button" aria-label="Close" (click)="onCancel()">
      <app-display-icon [icon]="icons.closeOutline"></app-display-icon>
    </button>
  </header>

  <div class="modal-body">
    @if (mode === 'confirm') {
      <p>
        The supplier <strong>{{ supplierCode }}</strong> is listed in Other Suppliers for this item.
        Would you like to automatically update the Supplier Stock Code to
        <strong>{{ stockCode }}</strong>?
      </p>
      <label class="do-not-ask-checkbox">
        <input
          type="checkbox"
          [checked]="doNotAskAgain()"
          (change)="onDoNotAskAgainChange($event)" />
        Do not ask again this session
      </label>
    } @else {
      <p>
        The supplier <strong>{{ supplierCode }}</strong> is listed in Other Suppliers, but no supplier stock code
        was found in supplier details for this item.
      </p>
      <p>The Supplier Stock Code field was not changed.</p>
    }
  </div>

  <footer class="modal-footer">
    @if (mode === 'confirm') {
      <app-shared-button [colour]="'primary'" (click)="onCancel()">
        Cancel
      </app-shared-button>
      <app-shared-button [fill]="true" (click)="onAccept()">
        Update Supplier Stock Code
      </app-shared-button>
    } @else {
      <app-shared-button [fill]="true" (click)="onCancel()">
        OK
      </app-shared-button>
    }
  </footer>
</section>
